(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonitorDeleteController',MonitorDeleteController);

    MonitorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Monitor'];

    function MonitorDeleteController($uibModalInstance, entity, Monitor) {
        var vm = this;

        vm.monitor = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Monitor.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
